<template>
  <basic-container>
    <avue-crud
        :option="option"
        :data="data"
        :page.sync="page"
        :search.sync="search"
        ref="crud"
        @row-del="rowDel"
        v-model="form"
        :permission="permissionList"
        @row-update="rowUpdate"
        @row-save="rowSave"
        :before-open="beforeOpen"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            v-if="permission.user_companyyy_add"
            @click="handleCompanyModel">模板下载
        </el-button>
        <el-upload
            v-if="permission.user_companyyy_add"
            :auto-upload="false"
            :on-change='handleImport'
            :show-file-list="false"
            action="#"
            class="filter-item">
          <el-button type="primary" size="small" icon="el-icon-upload2">导入</el-button>
        </el-upload>
        <el-button
            type="success"
            size="small"
            icon="el-icon-success"
            v-if="permission.user_companyyy_add"
            @click="handleStart('0')">一键开启
        </el-button>
        <el-button
            type="info"
            size="small"
            icon="el-icon-error"
            v-if="permission.user_companyyy_add"
            @click="handleStart('1')">一键关闭
        </el-button>
        <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            v-if="permission.user_companyyy_add"
            @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot="yyStart" slot-scope="scope">
        {{scope.row.yyStart === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            @change="switchYYChange($event, scope.row)"
            v-model="scope.row.yyStart">
        </el-switch>
      </template>
      <template slot="yyStartForm">
        {{form.yyStart === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            v-model="form.yyStart">
        </el-switch>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import mixin from '@/util/mixin'
import { batchYyStart, companyYyModelExcel, yyStart, isValidYyCode } from '@/api/user/companyyy'
import { importExcel } from '@/api/common'
import FileSaver from 'file-saver'

export default {
  mixins: [mixin],
  data () {
    const validateYyCode = (rule, value, callback) => {
      if (!value) {
        return
      }
      const id = this.form.id
      isValidYyCode(value, id).then(res => {
        const data = res.data
        if (!data) {
          callback(new Error('该用友编码已存在'))
        } else {
          callback()
        }
      })
    }
    return {
      module: 'user/companyyy',
      form: {},
      search: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        columnBtn: false,
        indexLabel: '序号',
        labelWidth: 140,
        searchMenuSpan: 5,
        column: [
          {
            label: '单位名称',
            prop: 'name',
            search: true,
            rules: [{
              required: true,
              message: '请输入单位名称'
            }]
          },
          {
            label: '区域',
            prop: 'area',
            search: true,
            type: 'select',
            dicUrl: '/sys/dict/code/area',
            rules: [{
              required: true,
              message: '请选择区域'
            }]
          },
          {
            label: '用友是否开始申报',
            prop: 'yyStart',
            slot: true,
            formslot: true,
            viewDisplay: false,
            editDisplay: false
          },
          {
            label: '用友编码',
            prop: 'yyCode',
            rules: [{
              required: true,
              validator: validateYyCode
            }]
          },
          {
            label: '邮箱1',
            prop: 'email1',
            hide: true
          },
          {
            label: '邮箱2',
            prop: 'email2',
            hide: true
          },
          {
            label: '邮箱3',
            prop: 'email3',
            hide: true
          },
          {
            label: '邮箱4',
            prop: 'email4',
            hide: true
          },
          {
            label: '邮箱5',
            prop: 'email5',
            hide: true
          }
        ]
      },
      data: []
    }
  },
  computed: {
    permissionList () {
      return {
        addBtn: this.permission.user_companyyy_add ? this.permission.user_companyyy_add : false,
        viewBtn: this.permission.user_companyyy_view ? this.permission.user_companyyy_view : false,
        delBtn: this.permission.user_companyyy_delete ? this.permission.user_companyyy_delete : false,
        editBtn: this.permission.user_companyyy_edit ? this.permission.user_companyyy_edit : false
      }
    }
  },
  methods: {
    switchYYChange ($event, row) {
      let msg = '***'
      if (row.yyStart === '0') {
        msg = '确定开启用友申报？'
      } else if (row.yyStart === '1') {
        msg = '确定关闭用友申报？'
      }
      this.$confirm(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        yyStart(row).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            row.yyStart = row.yyStart === '1' ? '0' : '1'
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function (e) {
        if (e === 'cancel' || e === 'close') {
          row.yyStart = row.yyStart === '1' ? '0' : '1'
        }
      })
    },
    handleStart (status) {
      let msg = '***'
      if (status === '0') {
        msg = '确定开启用友申报？'
      } else if (status === '1') {
        msg = '确定关闭用友申报？'
      }
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        batchYyStart(this.ids, status).then(res => {
          if (res.success) {
            this.onLoad(this.page, this.search)
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function (e) {})
    },
    handleCompanyModel () {
      companyYyModelExcel(this.module).then(res => {
        FileSaver.saveAs(res, '往来核销企业信息导入模板.xlsx')
      })
    },
    handleImport (file) {
      importExcel(this.module, file).then(res => {
        const that = this
        if (res.type === 'application/json') {
          const reader = new FileReader()
          reader.readAsText(res, 'utf-8')
          reader.onload = function () {
            res = JSON.parse(reader.result)
            if (res.success) {
              that.$message({
                type: 'success',
                message: '导入完成!'
              })
              that.onLoad(that.page)
            } else {
              that.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: '导入失败'
          })
          FileSaver.saveAs(res, '导入失败数据.xlsx')
        }
      }).catch(e => this.$message({
        type: 'error',
        message: '导入失败'
      }))
    }
  }
}
</script>
